import { hasSupabaseConfig, supabase } from './supabaseClient';

export interface PublicMedalist {
  id: string;
  studentName: string;
  className: string;
  olympiadName: string;
  olympiadAcronym: string;
  award: string;
  classification: string;
  phaseTitle: string;
}

interface PublicMedalistRow {
  id: string;
  student_name: string;
  class_name: string;
  olympiad_name: string;
  olympiad_acronym: string;
  award: string;
  classification: string;
  phase_title: string;
}

export async function listPublicMedalists(year: number): Promise<PublicMedalist[]> {
  if (!hasSupabaseConfig) return [];

  const { data, error } = await supabase.rpc('list_public_medalists', {
    p_year: year,
  });

  if (error || !Array.isArray(data)) return [];

  return (data as PublicMedalistRow[]).map((item) => ({
    id: item.id,
    studentName: item.student_name,
    className: item.class_name,
    olympiadName: item.olympiad_name,
    olympiadAcronym: item.olympiad_acronym,
    award: item.award,
    classification: item.classification,
    phaseTitle: item.phase_title,
  }));
}
